import { render, staticRenderFns } from "./GlslShader.vue?vue&type=template&id=24f20fc8&"
import script from "./GlslShader.vue?vue&type=script&lang=js&"
export * from "./GlslShader.vue?vue&type=script&lang=js&"
import style0 from "./GlslShader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports